// Small filters and a deterministic noise source shared by the Rhythm Lab's synthesized instruments (bell.ts, conga.ts). Not exported from index.ts.

/** Deterministic white noise in [-1, 1) for sample j (a fixed hash, not Math.random, so the same call gives the same samples). */
export function hashNoise(j: number): number {
  let x = Math.imul(j + 1013904223, 2654435761);
  x = Math.imul(x ^ (x >>> 15), 0x85ebca6b);
  x = Math.imul(x ^ (x >>> 13), 0xc2b2ae35);
  return ((x ^ (x >>> 16)) >>> 0) / 2147483648 - 1;
}

/** Second-order Butterworth section, in place (Float64): `kind` 'high' or 'low' at `hz`. */
export function butterworth(x: Float64Array, kind: 'high' | 'low', hz: number, sampleRate: number): void {
  const w = (2 * Math.PI * Math.min(hz, 0.45 * sampleRate)) / sampleRate;
  const cos = Math.cos(w);
  const alpha = Math.sin(w) / (2 * Math.SQRT1_2);
  const a0 = 1 + alpha;
  const sign = kind === 'high' ? 1 : -1;
  const b0 = ((1 + sign * cos) / 2) / a0;
  const b1 = (-sign * (1 + sign * cos)) / a0;
  const b2 = b0;
  const a1 = (-2 * cos) / a0;
  const a2 = (1 - alpha) / a0;
  let x1 = 0, x2 = 0, y1 = 0, y2 = 0;
  for (let i = 0; i < x.length; i++) {
    const x0 = x[i]!;
    const y0 = b0 * x0 + b1 * x1 + b2 * x2 - a1 * y1 - a2 * y2;
    x2 = x1; x1 = x0; y2 = y1; y1 = y0;
    x[i] = y0;
  }
}
